import { render, staticRenderFns } from "./LfGrayCounterComponent.vue?vue&type=template&id=099291d6&scoped=true"
import script from "./LfGrayCounterComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./LfGrayCounterComponent.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./LfGrayCounterComponent.vue?vue&type=style&index=0&id=099291d6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099291d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('099291d6')) {
      api.createRecord('099291d6', component.options)
    } else {
      api.reload('099291d6', component.options)
    }
    module.hot.accept("./LfGrayCounterComponent.vue?vue&type=template&id=099291d6&scoped=true", function () {
      api.rerender('099291d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/counters/LfGrayCounterComponent.vue"
export default component.exports